module.exports = __webpack_public_path__ + "img/Energy (framed).ca7dcdcc.png";